import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Bg from "../../assets/bg-grid.svg";
import BgTree from "../../assets/bg-tree.png";
import ExitBtn from "../../assets/exit-btn2.svg";
import Text from "../../components/Text";
import Button from "../../components/Button";
import { GameLoss } from "../../components/GameLoss"; // ✅ Import GameLoss
import { GameWin } from "../../components/GameWin";

const LossPageWrapper = styled.div`
  height: 100%;
  width: 100%;
  background-color: #72969b;
  background-image: url(${Bg});
  background-position: center;
  background-size: cover;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: end;
  z-index: 1000;
`;

const ContentWrapper = styled.div`
  margin: 35px 200px 0 200px;
  width: 90%;
  height: 85%;
  background-color: #3e626a;
  background-image: url(${BgTree});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
`;

const YellowLineExternal = styled.div`
  height: 100%;
  margin: 20px 20px 0 20px;
  border-top: 1px solid var(--highlight);
  border-left: 1px solid var(--highlight);
  border-right: 1px solid var(--highlight);
`;

const YellowLineInternal = styled.div`
  height: 100%;
  margin: 5px 5px 0 5px;
  border-top: 1px solid var(--highlight);
  border-left: 1px solid var(--highlight);
  border-right: 1px solid var(--highlight);
`;

const TextContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 200px;
`;

export const CastleLossPage = () => {
  const [shouldShowGameLoss, setShouldShowGameLoss] = useState(false);

  useEffect(() => {
    const allowReplay = sessionStorage.getItem("allow_replay_conquered") === "true";
    const conquered = JSON.parse(sessionStorage.getItem("conquered_castles") || "[]");
    const newlyConquered = JSON.parse(sessionStorage.getItem("newly_conquered_castles") || "[]");
    const failed = JSON.parse(sessionStorage.getItem("failed_castles") || "[]");
  
    const total = conquered.length + failed.length;
    const totalConquered = conquered.length;
  
    const gameWinCondition = allowReplay
      ? newlyConquered.length >= 9
      : total >= 11 && totalConquered >= 9;
  
    if (gameWinCondition) {
      console.log("🏆 Game finished through CastleLossPage — show GameWin");
      setShouldShowGameLoss("win");
    } else if (failed.length >= 3) {
      console.log("💀 3 failed castles — show GameLoss");
      setShouldShowGameLoss(true);
    }
  }, []);
  
  
  

  if (shouldShowGameLoss === true) {
    return <GameLoss />;
  }
  
  if (shouldShowGameLoss === "win") {
    return <GameWin />;
  }
  

  return (
    <LossPageWrapper>
      <ContentWrapper>
        <YellowLineExternal>
          <YellowLineInternal>
            <TextContainer>
              <Text
                fontFamily="'Source Serif 4'"
                fontSize="70px"
                fontWeight="700"
                color="#F3DE8A"
                lineheight="100%"
                padding="0 0  20px 0"
              >
                Καλή Προσπάθεια
              </Text>

              <Text
                fontFamily="Manrope"
                fontSize="20px"
                fontWeight="500"
                color="#F3DE8A"
                lineheight="100%"
                padding="0 0  50px 0"
              >
                Δεν καταφέρατε να κατεκτήσετε αυτό το κάστρο.
              </Text>

              <div style={{ marginTop: "60px" }}>
  <Button imgurl={ExitBtn} url="/play" />
</div>

            </TextContainer>
          </YellowLineInternal>
        </YellowLineExternal>
      </ContentWrapper>
    </LossPageWrapper>
  );
};
